<template>
  <div class="presupuestos-internos-datos">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card class="presupuesto-header collapsable-card">
          <template slot="header">Información del Presupuesto {{ incluirAdicionales? ' Consolidado' : '' }}</template>
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showHeader= !showHeader">
            <i :class="showHeader ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="header" class="mt-2" v-model="showHeader">
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Nro. PI"
                  label-for="presupuestoNumero"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="presupuestoNumero"
                    :value="presupuestoDatos.presupuestoNumero"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Cliente"
                  label-for="cliente"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="cliente"
                    :value="presupuestoDatos.cliente"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Acción"
                  label-for="accion"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="accion"
                    :value="presupuestoDatos.accion"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Contacto"
                  label-for="contacto"
                  :labelCols="labelCols"
                  v-if="verDatosContacto"
                  horizontal>
                  <b-form-input
                    id="contacto"
                    :value="presupuestoDatos.clienteContacto"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Tipo"
                  label-for="tipoPresupuesto"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="tipoPresupuesto"
                    :value="presupuestoDatos.tipoPresupuesto"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Nro.Orden"
                  label-for="numeroOrdenCompra"
                  description="Número de orden de compra"
                  :labelCols="labelCols"
                  v-if="verDatosOrdenCompra"
                  horizontal>
                  <b-form-input
                    id="numeroOrdenCompra"
                    :value="presupuestoDatos.numeroOrdenCompra"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Fecha Orden"
                  label-for="fechaOrdenCompra"
                  description="Fecha de orden de compra"
                  :labelCols="labelCols"
                  v-if="verDatosOrdenCompra"
                  horizontal>
                  <b-form-input
                    id="fechaOrdenCompra"
                    :value="presupuestoDatos.fechaOrdenCompra | fecha"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Descripción"
                  label-for="descripcionOrdenCompra"
                  description="Descripción de la orden de compra"
                  v-if="verDatosOrdenCompra"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="descripcionOrdenCompra"
                    :value="presupuestoDatos.descripcionOrdenCompra"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="Fecha de Entrega"
                  label-for="fechaEntrega"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-form-input
                      id="fechaEntrega"
                      :value="presupuestoDatos.fechaEntrega | fecha"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Prioridad"
                  label-for="prioridad"
                  :labelCols="labelCols * 2"
                  horizontal>
                  <b-form-input
                    id="prioridad"
                    :value="presupuestoDatos.prioridad"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Moneda"
                  label-for="moneda"
                  :labelCols="labelCols * 2"
                  horizontal>
                  <b-form-input
                    id="moneda"
                    :value="presupuestoDatos.moneda"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Cotización USD"
                  label-for="monedaCotizacion"
                  :labelCols="labelCols * 2"
                  horizontal>
                  <b-form-input
                    id="monedaCotizacion"
                    :value="presupuestoDatos.monedaCotizacion | moneda"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Fee Agencia"
                  label-for="feeAgencia"
                  :labelCols="labelCols * 2"
                  v-if="verDatosFee"
                  :description="descripcionFee"
                  horizontal>
                  <b-input-group>
                    <b-form-input
                      id="feeAgencia"
                      :value="presupuestoDatos.feeAgencia | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                    <b-input-group-append
                        class="filter-search-icons"
                        @click="consultarEscalasFee"
                        v-if="presupuestoDatos.aplicarEscalaFee">
                      <b-input-group-text>
                        <i class="fa fa-info"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Fee Diferenciado"
                  label-for="feeAgenciaPremios"
                  :labelCols="labelCols * 2"
                  horizontal
                  description="Fee de Agencia de Rubros Diferenciados"
                  v-if='presupuestoDatos.discriminarFeePremios & verDatosFee'>
                  <b-form-input
                    id="feeAgenciaPremios"
                    :value="presupuestoDatos.feeAgenciaPremios | porcentaje"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Pje Financiación"
                  label-for="pjeFinanciacion"
                  :labelCols="labelCols * 2"
                  v-if="verDatosFee"
                  :description="descripcionFinanciacion"
                  horizontal>
                  <b-input-group>
                    <b-form-input
                      id="pjeFinanciacion"
                      :value="presupuestoDatos.pjeFinanciacion | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                    <b-input-group-append
                        class="filter-search-icons"
                        @click="consultarEscalasFinanciacion"
                        v-if="presupuestoDatos.aplicarEscalaFinanciacion">
                      <b-input-group-text>
                        <i class="fa fa-info"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Fecha de Cierre"
                  label-for="fechaCierre"
                  :labelCols="labelCols * 2"
                  v-if="presupuestoCerrado"
                  horizontal>
                  <b-form-input
                    id="fechaCierre"
                    :value="presupuestoDatos.fechaCierre | fecha"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Reembolsos"
                  label-for="reembolsos"
                  :labelCols="labelCols * 2"
                  v-if="presupuestoDatos.reembolsos"
                  horizontal>
                  <b-form-input
                    id="reembolsos"
                    :value="presupuestoDatos.reembolsos? 'Presupuesto por Reembolsos' : ''"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Causa Social"
                  label-for="causaSocial"
                  :labelCols="labelCols * 2"
                  v-if="presupuestoDatos.causaSocial"
                  horizontal>
                  <b-form-input
                    id="causaSocial"
                    value="SI"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Causa Ambiental"
                  label-for="causaAmbiental"
                  :labelCols="labelCols * 2"
                  v-if="presupuestoDatos.causaAmbiental"
                  horizontal>
                  <b-form-input
                    id="causaAmbiental"
                    value="SI"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Propuesta Agencia"
                  label-for="propuestaAgencia"
                  :labelCols="labelCols * 2"
                  v-if="presupuestoDatos.propuestaAgencia"
                  horizontal>
                  <b-form-input
                    id="propuestaAgencia"
                    value="SI"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>

        <app-usuarios-propuesta ref="usuariosPropuesta" v-if="presupuestoDatos.propuestaAgencia"/>

        <app-usuarios ref="usuarios"/>

        <b-card header= "Provincias" class="presupuesto-header" v-if="seleccionProvincias">
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showProvincias= !showProvincias">
            <i :class="showProvincias ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="headerProvincias" class="mt-2" v-model="showProvincias">
            <b-row>
              <b-col>
                <b-table hover
                    responsive="sm"
                    class="registro"
                    :items="provincias"
                    :fields="provinciasFields">
                </b-table>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>

        <b-card header="Cancelación del Presupuesto" v-if="presupuestoCancelado" class="collapsable-card">
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showMotivosCancelacion= !showMotivosCancelacion">
            <i :class="showMotivosCancelacion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="motivoCancelacion" class="mt-2" v-model="showMotivosCancelacion">
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Fecha Cancelación"
                  label-for="fechaCancelacion"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="fechaCancelacion"
                    :value="presupuestoDatos.fechaCancelacion | fecha"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Usuario"
                  label-for="usuarioCancelacion"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="usuarioCancelacion"
                    :value="presupuestoDatos.usuarioCancelacion"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Motivo"
                  label-for="cancelacionMotivo"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-input
                    id="cancelacionMotivo"
                    :value="presupuestoDatos.cancelacionMotivo"
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Observaciones"
                  label-for="observacionesCancelacion"
                  description="Aclaraciones sobre el motivo de la cancelación"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-textarea
                    id="observacionesCancelacion"
                    readonly
                    :value="presupuestoDatos.observacionesCancelacion"
                    rows="3"
                    max-rows="5">
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>

        <b-card header="Aperturas/Cierres" v-if="aperturasCierresDatos.length != 0" class="collapsable-card">
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showAperturasCierres= !showAperturasCierres">
            <i :class="showAperturasCierres ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="aperturaCierre" class="mt-2" v-model="showAperturasCierres">
            <b-table
                small
                responsive="sm"
                :busy="tableBusy"
                class="registro aperturas-cierres"
                :items="aperturasCierresDatos"
                :fields="aperturasCierresFields">
              <template v-slot:cell(fechaRegistro)="data">
                {{ data.item.fechaRegistro | fechaHora }}
              </template>
            </b-table>
          </b-collapse>
        </b-card>

        <app-renglones
          ref="renglones"
          :opcionAsignarUsuarios="opcionAsignarUsuarios"
          :incluirAdicionales="incluirAdicionales"
          :vistaSimplificadaOrdenes="vistaSimplificadaOrdenes"
          @consultarAlternativas="consultarAlternativas">
        </app-renglones>

        <app-alternativas
          ref="alternativas"
          v-if="consultaAlternativas"
          @closeAlternativas="closeAlternativas">
        </app-alternativas>
        <!-- :accesoImagenes="accesoImagenes" -->

        <app-comisiones
          ref="comisiones"
          v-if="accesoComisiones">
        </app-comisiones>

        <app-facturacion
          ref="facturacion"
          v-if="accesoFacturacion">
        </app-facturacion>

        <b-card header="Totales" class="presupuesto-totales" v-if="Boolean(verTotales)">
          <!--<app-totales/>-->
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showTotales= !showTotales">
            <i :class="showTotales ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="totales" class="mt-2" v-model="showTotales">
            <form>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    v-if="tieneDescuentoOrdenes"
                    label="Cotización"
                    label-for="cotizacionBruta"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="cotizacionBruta"
                      :value="presupuestoDatos.cotizacionBruta | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="tieneDescuentoOrdenes"
                    label="Dto. Ordenes"
                    label-for="importeDescuentoOrdenes"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="importeDescuentoOrdenes"
                      :value="presupuestoDatos.importeDescuentoOrdenes | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Cotización"
                    label-for="cotizacionTotal"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="cotizacionTotal"
                      :value="presupuestoDatos.cotizacionTotal | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="grupo-controles"
                    label="Dto. Rebate"
                    label-for="importeDescuentoRebate"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="pjeDescuentoRebate"
                      :value="(presupuestoDatos.pjeDescuentoRebate * 100.00) | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                    <b-form-input
                      id="importeDescuentoRebate"
                      :value="presupuestoDatos.importeDescuentoRebate | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Subtotal"
                    label-for="subtotal"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="subtotal"
                      :value="(presupuestoDatos.cotizacionTotal - presupuestoDatos.importeDescuentoRebate) | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Financiación"
                    label-for="montoFinanciacion"
                    :label-cols="labelColsTotales"
                    :description="presupuestoDatos.feeSobreFinanciacion? 'Fee aplica sobre financiación' : ''"
                    horizontal>
                    <b-form-input
                      id="montoFinanciacion"
                      :value="presupuestoDatos.importeFinanciacion | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Fee"
                    label-for="importeFee"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="importeFee"
                      :value="(presupuestoDatos.importeFee + presupuestoDatos.importeFeePremios) | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Subtotal"
                    label-for="subtotal"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="subtotal"
                      :value="(presupuestoDatos.cotizacionTotal - presupuestoDatos.importeDescuentoRebate + presupuestoDatos.importeFinanciacion + presupuestoDatos.importeFee + presupuestoDatos.importeFeePremios) | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="grupo-controles"
                    label="Descuento"
                    label-for="importeDescuento"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="pjeDescuento"
                      :value="(presupuestoDatos.pjeDescuento * 100.00) | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                    <b-form-input
                      id="importeDescuento"
                      :value="presupuestoDatos.importeDescuento | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label="Neto"
                    label-for="importeNeto"
                    :label-cols="labelColsTotales"
                    v-if="presupuestoDatos.condicionFiscalId != 3"
                    horizontal>
                    <b-form-input
                      id="importeNeto"
                      :value="presupuestoDatos.importeNeto | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Impuestos"
                    label-for="importeImpuestos"
                    :label-cols="labelColsTotales"
                    v-if="presupuestoDatos.condicionFiscalId != 3"
                    horizontal>
                    <b-form-input
                      id="importeImpuestos"
                      :value="presupuestoDatos.importeImpuestos | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Total"
                    label-for="importeTotal"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="importeTotal"
                      :value="presupuestoDatos.importeTotal | moneda(presupuestoDatos.moneda)"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Total"
                    label-for="montoTotalPesos"
                    :label-cols="labelColsTotales"
                    horizontal
                    v-if="presupuestoDatos.monedaId != 101">
                    <b-form-input
                      id="montoTotalPesos"
                      :value="montoTotalPesos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="% Rent.Estimada"
                    label-for="pjeRentabilidad"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Rentabilidad total sobre la cotización y el costo interno">
                    <b-form-input
                      id="pjeRentabilidad"
                      :value="presupuestoDatos.pjeRentabilidad | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="% Rent. s/Reemb."
                    label-for="pjeRentabilidadSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Rentabilidad sobre la cotización y el costo interno excl. reembolsos">
                    <b-form-input
                      id="pjeRentabilidadSinReembolsos"
                      :value="presupuestoDatos.pjeRentabilidadSinReembolsos | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <!-- <b-form-group
                    label=""
                    label-for="pjeRentabilidadCosto"
                    :label-cols="3"
                    horizontal
                    description="Rentabilidad sobre el costo a partir del costo interno">
                    <b-form-input
                      id="pjeRentabilidadCosto"
                      :value="presupuestoDatos.pjeRentabilidadCosto | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group> -->

                  <b-form-group
                    label="Costo Real"
                    label-for="costoRealTotal"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Costo neto de compras, viáticos del personal y premios. Descuenta bonificaciones por comisiones.">
                    <b-form-input
                      id="costoReal"
                      :value="presupuestoDatos.costoRealTotal | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="% Rent.Real"
                    label-for="pjeRentabilidadReal"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Rentabilidad total sobre la cotización y el costo real">
                    <b-form-input
                      id="pjeRentabilidadReal"
                      :value="presupuestoDatos.pjeRentabilidadReal | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </form>
          </b-collapse>
        </b-card>

        <b-card header="Costos Reales" class="presupuesto-totales" v-if="discriminaCostos">
          <!--<app-totales/>-->
          <b-btn class="btn-collapse-card"
              variant="primary"
              size="sm"
              @click.prevent="showCostosReales= !showCostosReales">
            <i :class="showCostosReales? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="costosReales" class="mt-2" v-model="showCostosReales">
            <form>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="Ventas"
                    label-for="importeNetoFacturado"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="importeNetoFacturado"
                      :value="presupuestoDatos.importeNetoFacturado | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Compras"
                    label-for="costoRealCompras"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealCompras"
                      :value="presupuestoDatos.costoRealCompras | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Remitos"
                    label-for="costoRealRemitos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealRemitos"
                      :value="presupuestoDatos.costoRealRemitos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Premios"
                    label-for="costoRealPremios"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealPremios"
                      :value="presupuestoDatos.costoRealPremios | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Viáticos"
                    label-for="costoRealViaticos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealViaticos"
                      :value="presupuestoDatos.costoRealViaticos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Comisiones"
                    label-for="costoRealComisionesVendedores"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealComisionesVendedores"
                      :value="presupuestoDatos.costoRealComisionesVendedores | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Bonificaciones"
                    label-for="montoBonificacionComisiones"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="montoBonificacionComisiones"
                      :value="presupuestoDatos.montoBonificacionComisiones | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Total"
                    label-for="costoRealTotal"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealTotal"
                      :value="presupuestoDatos.costoRealTotal | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="% Rent.Real"
                    label-for="pjeRentabilidadSobreVentasReal"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Rentabilidad total sobre la facturación y el costo real">
                    <b-form-input
                      id="pjeRentabilidadSobreVentasReal"
                      :value="presupuestoDatos.pjeRentabilidadSobreVentasReal | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label="Ventas s/Reemb."
                    label-for="importeNetoFacturadoSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="importeNetoFacturadoSinReembolsos"
                      :value="presupuestoDatos.importeNetoFacturadoSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Compras s/Reemb."
                    label-for="costoRealComprasSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealComprasSinReembolsos"
                      :value="presupuestoDatos.costoRealComprasSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Remitos s/Reemb."
                    label-for="costoRealRemitosSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealRemitosSinReembolsos"
                      :value="presupuestoDatos.costoRealRemitosSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label=""
                    label-for="costoRealPremiosSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealPremiosSinReembolsos"
                      value=""
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Viáticos s./Reemb."
                    label-for="costoRealViaticosSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealViaticosSinReembolsos"
                      :value="presupuestoDatos.costoRealViaticosSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Comisiones s/Reemb."
                    label-for="costoRealComisionesVendedoresSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealComisionesVendedoresSinReembolsos"
                      :value="presupuestoDatos.costoRealComisionesVendedoresSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Bonificaciones s/Reemb."
                    label-for="montoBonificacionComisionesSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="montoBonificacionComisionesSinReembolsos"
                      :value="presupuestoDatos.montoBonificacionComisionesSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Total s/Reemb."
                    label-for="costoRealTotalSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal>
                    <b-form-input
                      id="costoRealTotalSinReembolsos"
                      :value="presupuestoDatos.costoRealTotalSinReembolsos | moneda"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="verRBSinReembolsos"
                    label="% Rent.Real s/Reemb."
                    label-for="pjeRentabilidadSobreVentasRealSinReembolsos"
                    :label-cols="labelColsTotales"
                    horizontal
                    description="Rentabilidad sobre la facturación y el costo real excl.reembolsos">
                    <b-form-input
                      id="pjeRentabilidadSobreVentasRealSinReembolsos"
                      :value="presupuestoDatos.pjeRentabilidadSobreVentasRealSinReembolsos | porcentaje"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </form>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item @click.stop="editar"
              v-if="opcionEditarPresupuesto & !presupuestoCancelado & !presupuestoCerrado & !incluirAdicionales">
            <i class="fa fa-edit"></i>Editar Presupuesto</b-dropdown-item>

          <b-dropdown-item @click.stop="editarProduccion"
              v-if="opcionEditarProduccion & !presupuestoCancelado & !presupuestoCerrado & !incluirAdicionales">
            <i class="fa fa-edit"></i>Editar Información de Producción</b-dropdown-item>

          <b-dropdown-item @click.stop="autorizar"
              v-if="opcionAutorizarPresupuesto & !presupuestoAutorizado & !presupuestoCancelado & !presupuestoCerrado">
            <i class="fa fa-check"></i>Autorizar Presupuesto</b-dropdown-item>

          <b-dropdown-item @click.stop="cancelarAutorizacion"
              v-if="opcionAutorizarPresupuesto & presupuestoAutorizado & !presupuestoCancelado & !presupuestoCerrado">
            <i class="fa fa-remove"></i>Cancelar Autorizacion</b-dropdown-item>

          <b-dropdown-item @click.stop="emitirPresupuestoCliente"
              v-if="exportarPDFCliente & !presupuestoCancelado & !incluirAdicionales">
            <i class="fa fa-file-pdf-o"></i>Emitir Presupuesto al Cliente</b-dropdown-item>

          <!-- <b-dropdown-divider  v-if="accesoComisiones & tieneSaldoComision"></b-dropdown-divider>

          <b-dropdown-item @click.stop="cancelarSaldoComision"
              v-if="accesoComisiones & tieneSaldoComision & !saldoComisionCancelado">
            <i class="fa fa-ban"></i>
            Cancelar Saldo Comisión</b-dropdown-item>

          <b-dropdown-item @click.stop="anularCancelacionSaldoComision"
              v-if="accesoComisiones & tieneSaldoComision & saldoComisionCancelado">
            <i class="fa fa-remove"></i>Anular Cancelación de Saldo Comisión</b-dropdown-item> -->

          <b-dropdown-divider/>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="autorizacionModal"
        title="Autorizar Presupuesto"
        header-bg-variant= "light"
        hide-footer
        lazy
        modal-class="modalABM">
      <app-observaciones
        @save="saveAutorizacion"
        @cancelar="closeAutorizacion">
      </app-observaciones>
    </b-modal>

    <b-modal ref="escalasFeeModal"
        title="Escalas Fee"
        header-bg-variant= "light"
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-escalas-fee
        :escalasFee="presupuestoDatos.escalasFee">
      </app-escalas-fee>
    </b-modal>

    <b-modal ref="escalasFinanciacionModal"
        title="Escalas Financiacion"
        header-bg-variant= "light"
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-escalas-financiacion
        :escalasFinanciacion="presupuestoDatos.escalasFinanciacion">
      </app-escalas-financiacion>
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Usuarios from './UsuariosData';
import UsuariosPropuesta from './UsuariosPropuestaData';
import Renglones from './RenglonesData';
import Alternativas from './AlternativasData.vue';
import Facturacion from './FacturacionData.vue';
import Comisiones from './ComisionesData.vue';
import Observaciones from '../shared/observacionesModal.vue';
import EscalasFee from './EscalasFee.vue';
import EscalasFinanciacion from './EscalasFinanciacion.vue';
import exportPDFPresupuestoCliente from '../../mixins/export_presupuesto_cliente_pdf';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'PresupuestoInternoData',
  components: {
    appUsuarios: Usuarios,
    appUsuariosPropuesta: UsuariosPropuesta,
    appRenglones: Renglones,
    appAlternativas: Alternativas,
    appFacturacion: Facturacion,
    appComisiones: Comisiones,
    appObservaciones: Observaciones,
    appEscalasFee: EscalasFee,
    appEscalasFinanciacion: EscalasFinanciacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [
    exportPDFPresupuestoCliente,
    msjModal,
    confirmModal
  ],
  props: {
    incluirAdicionales: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      presupuestoId: 0,
      exportarPDFCliente: false,
      opcionEditarPresupuesto: false,
      opcionEditarProduccion: false,
      verDatosContacto: false,
      verDatosOrdenCompra: false,
      verDatosFee: false,
      verTotales: false,
      opcionAsignarUsuarios: false,
      vistaSimplificadaOrdenes: false,
      verRBSinReembolsos: false,

      tableBusy: false,
      showHeader: true,
      showProvincias: false,
      showMotivosCancelacion: true,
      showAperturasCierres: false,
      showTotales: true,
      showCostosReales: false,

      provinciasFields: [
        { key: 'provincia' },
      ],

      aperturasCierresFields: [
        {
          key: 'fechaRegistro',
          label: 'Fecha',
        },
        {
          key: 'movimiento',
          label: 'Tipo de Movimiento',
        },
        {
          key: 'usuario',
        },
        {
          key: 'observaciones',
        },
      ],

      labelCols: 2,
      labelColsTotales: 4,
      ordenTrabajoId: 0,
      accesoComisiones: false,
      opcionAutorizarPresupuesto: false,
      accesoFacturacion: false
    }
  },
  created() {
    this.presupuestoId = this.$route.params.id;

    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
      case 1: /* Superadmin*/
      case 2: /* Direccion */
      case 3: /* Cuentas */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 12: /* Asistente de promociones */
      case 13: /* Asistente de cuentas */
      case 15: /* Coordinador/a de promociones */
      case 23: /* Asistente de Calidad */
        this.opcionEditarPresupuesto = true;
        this.opcionEditarProduccion = true;
        this.exportarPDFCliente = true;
        this.verDatosContacto = true;
        this.verDatosOrdenCompra = true;
        this.verDatosFee = true;
        this.verTotales = true;
        this.opcionAsignarUsuarios = true;
        break;

      case 4: /* Produccion */
      case 5: /* Diseño */
      case 14: /* Asistente de produccion */
      case 24: /* Coordinador/a de diseño */
        this.opcionEditarProduccion = true;
        this.verTotales = true;
        this.vistaSimplificadaOrdenes = true;
        break;

      case 16: /* Ejecutivo comercial */
      case 17: /* Asistente comercial */
      case 19: /* Coordinador/a comercial */
      case 20: /* Gerente Comercial */
        this.opcionEditarPresupuesto = true;
        this.opcionEditarProduccion = true;
        this.exportarPDFCliente = true;
        this.verDatosContacto = true;
        this.verDatosOrdenCompra = true;
        this.verDatosFee = true;
        this.verTotales = true;
        this.opcionAsignarUsuarios = true;
        break;
    }

    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
        this.opcionAutorizarPresupuesto = true;
        break;
    }

    switch (userRolId) {
      case 1:
      case 8: /* Calidad */
        this.verRBSinReembolsos = true;
        break;
    }

    this.accesoFacturacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosFacturacionEstimada'));
    this.accesoComisiones = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosComisiones'));

    this.getPresupuesto();
  },
  computed: {
    ...mapFields([
      'presupuestoDatos',
      'ordenesDatos',
      'ordenesDatosTotales',
      // 'presupuestoTotalesDatos',
      'vistaOrdenesDatos',
      'vistaTotalesRenglon',
      'vistaOrdenesDatosTotales',
      'aperturasCierresDatos',
      'ordenesAlternativasDatos',
      'vendedorComision'
    ]),
    presupuestoCancelado() {
      if (this.presupuestoDatos.cancelacionMotivoId) {
        if (this.presupuestoDatos.cancelacionMotivoId != 0) {
          return true;
        }
      }
      return false;
    },
    presupuestoCerrado() {
      if ( moment(this.presupuestoDatos.fechaCierre).format('YYYY-MM-DD') == '1900-01-01') {
        return false;
      }
      return true;
    },
    presupuestoAutorizado() {
      return (/true/i).test(this.presupuestoDatos.autorizado);
    },
    provincias() {
      return this.presupuestoDatos.presupuestoInternoProvincias;
    },
    seleccionProvincias() {
      return this.presupuestoDatos.seleccionProvincias;
    },
    consultaAlternativas() {
      if (this.ordenesAlternativasDatos) {
        if (this.ordenesAlternativasDatos.length != 0) {
          return true;
        }
      }
      return false;
    },
    tieneDescuentoOrdenes() {
      if (this.presupuestoDatos) {
        if (this.presupuestoDatos.importeDescuentoOrdenes) {
          return this.presupuestoDatos.importeDescuentoOrdenes != 0;
        }
      }
      return false;
    },
    montoTotalPesos() {
      return parseFloat(this.presupuestoDatos.importeTotal) * parseFloat(this.presupuestoDatos.monedaCotizacion);
    },
    descripcionFee() {
      if (this.presupuestoDatos.aplicarEscalaFee) {
        return 'Aplica escala de porcentajes';
      }
      return null;
    },
    descripcionFinanciacion() {
      if (this.presupuestoDatos.aplicarEscalaFinanciacion) {
        return 'Aplica escala de porcentajes';
      }
      return null;
    },
    tieneSaldoComision() {
      if (this.vendedorComision) {
        return parseFloat(this.vendedorComision.saldo) > 0;
      }
      return false;
    },
    saldoComisionCancelado() {
      if (this.vendedorComision) {
        return this.vendedorComision.saldoCancelado;
      }
      return false;
    },
    discriminaCostos() {
      if (this.presupuestoDatos.discriminaCostos) {
        return (/true/i).test(this.presupuestoDatos.discriminaCostos);
      }
      return false;
    },

  },
  methods: {
    getPresupuesto() {
      let params = {
        presupuestoId: this.presupuestoId,
        incluirAdicionales: this.incluirAdicionales
      }

      this.tableBusy = true;
      this.$store.dispatch('presupuestoInternoDatos/getDatos', params)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack() {
      this.$router.go(-1)
    },
    editar() {
      if (!this.presupuestoCerrado) {
        this.$router.push({ name: 'PresupuestoInternoABM',
                            params: { id: this.presupuestoId }})
      }
    },
    editarProduccion() {
      this.$router.push({ name: 'PresupuestoInternoProduccion',
                          params: { id: this.presupuestoId }});
    },
    exportXLS() {
      this.exportXLSPresupuestoInterno(this.$store.getters['presupuestoInternoDatos/presupuestoDatosRpt'],
        this.ordenesDatos);
    },
    exportPDF() {
      this.exportPDFPresupuestoInterno(this.$store.getters['presupuestoInternoDatos/presupuestoDatosRpt'],
        this.ordenesDatos);
    },
    emitirPresupuestoCliente() {
      let empresa = {};

      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          return;
        })
        .then(() => {
          return this.$store.dispatch('presupuestoCliente/getPresupuestoCliente', this.presupuestoId);
        })
        .then(() => {
          let presupuesto = this.$store.getters['presupuestoCliente/presupuesto'];

          this.exportPDFPresupuestoCliente(presupuesto, empresa);
          // let presupuestos = this.$store.getters['presupuestoCliente/presupuestos'];
          // if (presupuestos) {
          //   this.exportPDFPresupuestoCliente(presupuestos[0].presupuesto,
          //     presupuestos[0].ordenes, empresa);
          // }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultarAlternativas(ordenTrabajoId) {
      this.$store.dispatch('presupuestoInternoDatos/consultarAlternativas', ordenTrabajoId)
      .catch(error => this.showErrorMsj(error));
    },
    closeAlternativas() {
      this.$store.dispatch('presupuestoInternoDatos/clearConsultaAlternativas')
      .catch(error => this.showErrorMsj(error));
    },
    autorizar() {
      this.$refs.autorizacionModal.show();
    },
    saveAutorizacion(params) {
      this.$refs.autorizacionModal.hide();
      params.presupuestoInternoId = this.presupuestoId;
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/autorizarPresupuesto', params)
        .then(() => {
          this.showModalMsj('El presupuesto se autorizó con éxito', null, null, 'light');
          this.getPresupuesto();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    closeAutorizacion() {
      this.$refs.autorizacionModal.hide();
    },
    cancelarAutorizacion() {
      this.showModalConfirm('¿Desea cancelar la autorización del presupuesto?',
        this.cancelar, 'Si', null, 'No');
    },
    cancelar() {
      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/cancelarAutorizacionPresupuesto', this.presupuestoId)
        .then(() => {
          this.showModalMsj('La autorización del presupuesto se canceló con éxito', null, null, 'light');
          this.getPresupuesto();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    consultarEscalasFee() {
      this.$refs.escalasFeeModal.show();
    },
    consultarEscalasFinanciacion() {
      this.$refs.escalasFinanciacionModal.show();
    },
    // cancelarSaldoComision() {
    //   this.showModalConfirm('¿Desea cancelar el saldo a facturar por la comisión del vendedor?',
    //     this.cancelarSaldoComisionVendedor, 'Si', null, 'No');
    // },
    // cancelarSaldoComisionVendedor() {
    //   this.showSpinner();
    //   this.$store.dispatch('presupuestosinternos/cancelarSaldoVendedorComision', this.presupuestoId)
    //     .then(() => {
    //       return this.$store.getters['presupuestosinternos/vendedorComision'];
    //     })
    //     .then(vendedorComision => {
    //       return this.$store.dispatch('presupuestoInternoDatos/setCancelacionSaldoComision', vendedorComision);
    //     })
    //     .then(() => this.showModalMsj('La cancelación del saldo a facturar por la comisión del vendedor se realizó con éxito', null, null, 'light'))
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },
    // anularCancelacionSaldoComision() {
    //   this.showModalConfirm('¿Desea anular la cancelación del saldo a facturar por la comisión del vendedor?',
    //     this.anularCancelacionSaldoComisionVendedor, 'Si', null, 'No');
    // },
    // anularCancelacionSaldoComisionVendedor() {
    //   this.showSpinner();
    //   this.$store.dispatch('presupuestosinternos/anularCancelacionSaldoVendedorComision', this.presupuestoId)
    //     .then(() => {
    //       return this.$store.dispatch('presupuestoInternoDatos/anularCancelacionSaldoComision', this.presupuestoId)
    //     })
    //     .then(() => this.showModalMsj('La anulación de la cancelación del saldo a facturar por la comisión del vendedor se realizó con éxito', null, null, 'light'))
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // }
  }
}
</script>

<style>
  div.presupuesto-header .card-body,
  div.presupuesto-totales .card-body {
    padding: 0;
  }
  div.presupuesto-header .card-body > div,
  div.presupuesto-totales .card-body > div {
    padding: 20px;
    /*padding-top: 15px;*/
  }

  /* Aperturas/Cierres */
  .presupuestos-internos-datos .registro.aperturas-cierres table td {
    vertical-align: middle;
    border: none;
  }
  .presupuestos-internos-datos .registro.aperturas-cierres table td[aria-colindex="1"] {
    width: 15%;
  }
  .presupuestos-internos-datos .registro.aperturas-cierres table td[aria-colindex="2"] {
    width: 15%;
  }
  .presupuestos-internos-datos .registro.aperturas-cierres table td[aria-colindex="3"] {
    width: 20%;
  }
  .presupuestos-internos-datos .registro.aperturas-cierres table td[aria-colindex="4"] {
    width: 50%;
  }

  .presupuestos-internos-datos .grupo-controles .col {
    display: inline-flex;
  }

  .presupuestos-internos-datos .grupo-controles #pjeDescuento,
  .presupuestos-internos-datos .grupo-controles #importeDescuento,
  .presupuestos-internos-datos .grupo-controles #pjeDescuentoRebate,
  .presupuestos-internos-datos .grupo-controles #importeDescuentoRebata {
    display: inline-block;
  }
  .presupuestos-internos-datos .grupo-controles #pjeDescuento,
  .presupuestos-internos-datos .grupo-controles #pjeDescuentoRebate {
    width: 25%;
  }
  .presupuestos-internos-datos .grupo-controles #importeDescuento,
  .presupuestos-internos-datos .grupo-controles #importeDescuentoRebate {
    width: 72%;
    margin-left: 3%;
  }
</style>
